var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"qrcode",staticStyle:{"margin":"auto","padding":"10px"}})
}
var staticRenderFns = []

export { render, staticRenderFns }